// 后端api
import { logoutApi, checkApi, getUserInfoApi } from '@/api/user.js'
import { getEmployeeInfoApi, getJoinCompanyApi } from '@/api/employee'
import {
  queryValueAddedServiceAccountBalanceApi,
  queryValueAddedServiceCategoryRightsApi,
  queryValueAddedServiceProductRightsApi
} from '@/api/value-added-service'
import {
  valueAddedCategoryCodeDict,
  valueAddedEffectTypeDict
} from '@/dictionary/value-added-service'
import Cookies from 'js-cookie'

const state = {
  // 标识用户登录，及登录平台的字段
  isLogin: false, // 是否登录， false未登录， true登录
  loginIdentity: [], // 登录的用户角色, 企业员工-purchase、专家-expert

  // ------- 用户信息 -------
  userId: '', // 用户ID
  face: '', // 头像
  userStatus: '', // 用户状态：0：禁用 1：启用
  userName: '',
  userMobile: '',
  nickname: '',
  userEmail: '',
  wxMpOpenid: '', // 微信公众号openId
  wechatNickname: '',

  // 员工信息，（专家信息不获取）
  mobile: '', // 手机号
  employeeEmail: '', // 员工邮箱
  employeeName: '', // 员工姓名
  employeeId: '', // 员工id
  employeeStatus: '', // 员工状态 0：禁用 1：启用

  // 用户加入的公司列表
  companyList: [],

  // 用户会员信息
  vipInfo: {},
  // 用户会员权益余额
  vipBalance: {}
}

const getters = {
  // 会员有效中
  inVip: state => state.vipInfo?.rightsId && !state.vipInfo?.isExpire
}

const mutations = {
  // ------------ 标识用户登录，及登录平台的字段 ---------------
  UPDATE_LOGIN: (state, isLogin) => {
    state.isLogin = isLogin
  },
  SET_USER_IDENTITY: (state, identity) => {
    state.loginIdentity = identity
  },

  // ------------- 用户信息 -----------------
  SET_USER_ID: (state, id) => (state.userId = id),
  SET_USER_FACE: (state, face) => (state.face = face),
  SET_USER_STATUS: (state, status) => (state.userStatus = status),
  SET_USER_NAME: (state, name) => (state.userName = name),
  SET_USER_MOBILE: (state, mobile) => (state.userMobile = mobile),
  SET_USER_NICKNAME: (state, nickname) => (state.nickname = nickname),
  SET_USER_EMAIL: (state, email) => (state.userEmail = email),
  SET_USER_WX_MP_OPEN_ID: (state, wxMpOpenId) =>
    (state.wxMpOpenid = wxMpOpenId),

  // ------------- 员工信息，（专家信息不获取）-----------------
  SET_EMPLOYEE_MOBILE: (state, mobile) => {
    state.mobile = mobile
  },
  SET_EMPLOYEE_NAME: (state, name) => {
    state.employeeName = name
  },
  SET_EMPLOYEE_EMAIL: (state, email) => {
    state.employeeEmail = email
  },
  SET_EMPLOYEE_ID: (state, employeeId) => {
    state.employeeId = employeeId
  },
  SET_EMPLOYEE_STATUS: (state, employeeStatus) => {
    state.employeeStatus = employeeStatus
  },

  // --------------- 用户加入的公司列表 ------------------
  SET_COMPANY_LIST: (state, companyList) => {
    state.companyList = companyList
  },

  // 用户会员信息
  SET_VIP_INFO: (state, vipInfo) => {
    state.vipInfo = vipInfo
  },

  // 添加用户会员权益余额信息
  ADD_VIP_BALANCE: (state, vipBalance) => {
    state.vipBalance = Object.assign({}, state.vipBalance, vipBalance)
  }
}

const actions = {
  // 获取用户的登录状态及登录平台（云采购、专家）信息
  checkLoginState({ commit }) {
    return new Promise((resolve, reject) => {
      checkApi()
        .then(res => {
          const identity = []
          if (res.data.purchase) {
            identity.push('purchase')
          }
          if (res.data.expert) {
            identity.push('expert')
          }
          commit('UPDATE_LOGIN', true)
          commit('SET_USER_IDENTITY', identity || [])
          resolve(res)
        })
        .catch(err => {
          const domain = `.${window.location.hostname
            .split('.')
            .slice(-2)
            .join('.')}`
          commit('UPDATE_LOGIN', false)
          Cookies.remove('X-JCZH-AC', { domain })
          reject(err)
        })
    })
  },

  // 获取用户信息
  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfoApi()
        .then(res => {
          const data = res?.data || {}

          commit('SET_USER_ID', data.userId)
          commit('SET_USER_FACE', data?.userInfo?.face || '')
          commit('SET_USER_STATUS', data?.status)
          commit('SET_USER_NAME', data?.credentials?.userName || '')
          commit('SET_USER_MOBILE', data?.credentials?.mobile || '')
          commit('SET_USER_NICKNAME', data?.userInfo?.nickname || '')
          commit('SET_USER_EMAIL', data?.userInfo?.email || '')
          commit(
            'SET_USER_WX_MP_OPEN_ID',
            data?.thirdPartyAccount?.wxMpOpenid || ''
          )

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 获取员工信息
  getEmployeeInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getEmployeeInfoApi()
        .then(res => {
          const data = res?.data || {}

          commit('SET_EMPLOYEE_MOBILE', data.userInfo.mobile || '')
          commit('SET_EMPLOYEE_EMAIL', data.employeeInfo.email || '')
          commit('SET_EMPLOYEE_NAME', data.employeeInfo.name || '')
          commit('SET_EMPLOYEE_ID', data.employeeId || '')
          commit('SET_EMPLOYEE_STATUS', data.status || '')

          resolve(data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 获取已加入企业
  getJoinedCompany({ commit, state }) {
    return new Promise((resolve, reject) => {
      getJoinCompanyApi()
        .then(res => {
          commit('SET_COMPANY_LIST', res.data || [])
          resolve(res.data || [])
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 退出登录
  logout({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      logoutApi()
        .then(res => {
          dispatch('resetUser').then(res2 => {
            resolve(res)
          })
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 重置用户
  resetUser({ commit }) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_LOGIN', false)
      commit('SET_USER_IDENTITY', [])
      resolve()
    })
  },

  // 查询用户会员权益信息
  getVipInfo({ commit }) {
    return new Promise((resolve, reject) => {
      queryValueAddedServiceCategoryRightsApi(
        valueAddedCategoryCodeDict.VIP.value
      )
        .then(res => {
          const vipInfoList = res.data || []
          if (vipInfoList.length === 0) {
            commit('SET_VIP_INFO', {})
            resolve(res)
            return
          }

          // 有会员权益的情况下，取第一个会员权益
          const vipInfo = vipInfoList.find(item => !item.isExpire) || {}
          commit('SET_VIP_INFO', vipInfo)
          resolve(res)
        })
        .catch(err => reject(err))
    })
  },

  // 查询用户会员权益余额信息
  getVipBalance({ commit }, productList) {
    return new Promise((resolve, reject) => {
      const promiseList = productList.map(item => {
        if (item.effectType === valueAddedEffectTypeDict.TIME.value) {
          return queryValueAddedServiceProductRightsApi(item.value)
        }
        if (item.effectType === valueAddedEffectTypeDict.COUNT.value) {
          return queryValueAddedServiceAccountBalanceApi(item.value)
        }
      })
      Promise.allSettled(promiseList)
        .then(res => {
          const balance = {}
          const list = res || []
          list.forEach((item, index) => {
            const productCode = productList[index].value
            balance[productCode] = item.value?.data || {}
          })
          commit('ADD_VIP_BALANCE', balance)
          resolve(res)
        })
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
